import React from 'react';
import PropTypes from 'prop-types';
import Title from '../../common/Title';

export default class LocationSection extends React.Component {
  render() {
    return (
      <div>
        <Title text="Location" />
        <div dangerouslySetInnerHTML={{ __html: this.props.location }} />
      </div>
    );
  }
}

LocationSection.propTypes = {
  location: PropTypes.string.isRequired
};
